import { React, useState, useEffect } from "react";
import { API_URL } from "../../shared/constant";
import { toast, ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const LoginComponent = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email && password) {
      setLoading(true);
      axios.post(API_URL.LOGIN_URL, { email: email, password: password }).then(
        (res) => {
          if (res.data.access_token) {
            sessionStorage.setItem("access_token", res.data.access_token);
            sessionStorage.setItem("user_name", res.data.user_name);
            sessionStorage.setItem("logo", res.data.logo);
            sessionStorage.setItem("my_id", res.data.my_id.toString());
            if (res.data.my_id == 1000) {
              navigate("/dashboard", { replace: true });
            } else if (res.data.my_id == 100) {
              navigate("/master-dashboard", { replace: true });
            } else {
              sessionStorage.clear();
              navigate("/", { replace: true });
            }
          } else {
            toast.error("Invalid Username or Password", { autoClose: 3000 });
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            
          });
        }
      );
    } else {
      toast.error("Please valid Username and Password", {
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    const access_token = sessionStorage.getItem("access_token");
    const my_id = sessionStorage.getItem("my_id");
    if (access_token && my_id) {
      if (my_id == "1000") {
        navigate("/dashboard", { replace: true });
      } else if (my_id == "100") {
        navigate("/master-dashboard", { replace: true });
      } else {
        sessionStorage.clear();
        navigate("/", { replace: true });
      }
    }
  }, []);

  return (
    <>
      <div className="fixed-background"></div>
      <main>
        <div className="container">
          <div className="row h-100">
            <div className="col-12 col-md-10 mx-auto my-auto">
              <div className="card auth-card">
                <div className="position-relative image-side ">

                  <p className=" text-white h2">Aawa Tiles</p>

                  <p className="white mb-0">
                    Please use your credentials to login.
                    {/* If you are not a member, please
                    <a href="#" className="white">register</a>. */}
                  </p>
                </div>
                <div className="form-side">
                  <span className="logo-single" style={{width: '100%', height: 'auto', marginBottom: 30, textAlign: 'center'}}>
                    <img src={"/assets/img/logo.png"} className="img-fluid logo" alt="Aawa Tiles"  style={{width: 150, height: 'auto'}} />
                  </span>
                  <h6 className="mb-4">Login</h6>
                  <form onSubmit={handleSubmit}>
                    <label className="form-group has-float-label mb-4">
                      <input type="email" className="form-control" onChange={(e) => setEmail(e.target.value)} />
                      <span>E-mail</span>
                    </label>

                    <label className="form-group has-float-label mb-4">
                      <input type="password" className="form-control pass-input" onChange={(e) => setPassword(e.target.value)} />
                      <span>Password</span>
                    </label>
                    <div className="d-flex justify-content-between align-items-center">
                      <Link to={'/'}>Forget password?</Link>

                      <button className="btn btn-primary btn-lg btn-shadow" type="submit">{isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      ) : null} LOGIN</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
};
export default LoginComponent;
